// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import LectureLessonStatusResourceViewModel from '../../../../viewModel/resource/LectureLessonStatusResourceViewModel';
import LectureLessonStatusResourceDTO from '../../dto/resource/LectureLessonStatusResourceDTO';

export default abstract class LectureLessonStatusResourceModel extends BaseModel<LectureLessonStatusResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  * @type {int64}
  */
  get toccoId() { return this.dto.toccoId; }
  set toccoId(value) { this.dto.toccoId = value; }
  /**
  */
  get toccoUniqueId() { return this.dto.toccoUniqueId; }
  set toccoUniqueId(value) { this.dto.toccoUniqueId = value; }
  /**
  */
  get name() { return this.dto.name; }
  set name(value) { this.dto.name = value; }
  /**
  */
  get htmlColor() { return this.dto.htmlColor; }
  set htmlColor(value) { this.dto.htmlColor = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    value = Number.parseFloat(qs.toccoid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.toccoId = value;
    this.dto.toccoUniqueId = qs.toccouniqueid;
    this.dto.name = qs.name;
    this.dto.htmlColor = qs.htmlcolor;
  }
}
